var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerPagesScalable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pp_filter0_f"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pp_filter1_f"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pp_paint0_linear",
    x1: 17.3997,
    y1: 2.10083,
    x2: 43.0799,
    y2: 94.0143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A391E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685CD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pp_paint1_linear",
    x1: 94,
    y1: 86.0005,
    x2: 76.5,
    y2: 35.5006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38389F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B44C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pp_paint2_linear",
    x1: 35.2102,
    y1: -12.4822,
    x2: 60.0759,
    y2: 60.2955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0AFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pp_paint3_linear",
    x1: 21.9912,
    y1: -3.25494,
    x2: 48.766,
    y2: 92.3691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0AFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8675DD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pp_clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pp_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pp_clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pp_clip1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pp_mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0015 1.29095C49.2237 -0.0423787 46.7792 -0.0423776 45.0015 1.29096L2.33529 33.2906C-0.33138 35.2906 -0.33138 39.2906 2.33529 41.2906L23.5208 57.1797L14.5736 63.8902C11.9069 65.8902 11.9069 69.8902 14.5736 71.8902L44.9999 94.7099C46.7776 96.0432 49.2221 96.0432 50.9999 94.7099L93.666 62.7103C96.3327 60.7103 96.3327 56.7103 93.666 54.7103L72.4805 38.8211L81.4278 32.1107C84.0944 30.1107 84.0944 26.1107 81.4278 24.1107L51.0015 1.29095Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pp_mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24023 67.8902L60.2397 29.6406L98.9994 58.7103L47.9999 96.9599L9.24023 67.8902Z",
    fill: "url(#pp_paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5195 57.1803L60.2392 29.6406L98.9988 58.7103L65.2792 84C63.5014 85.3333 61.0569 85.3334 59.2792 84L23.5195 57.1803Z",
    fill: "url(#pp_paint1_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pp_filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.99805 37.6906L48.0015 -0.559021L86.7611 28.5107L38.7616 64.5103C36.9838 65.8437 34.5394 65.8437 32.7616 64.5103L-2.99805 37.6906Z",
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pp_filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.99805 39.2906L48.0015 1.04095L86.7611 30.1107L38.7616 66.1103C36.9838 67.4436 34.5394 67.4436 32.7616 66.1103L-2.99805 39.2906Z",
    fill: "black",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-2.99805 37.2906L48.0015 -0.959045L86.7611 28.1107L38.7616 64.1103C36.9838 65.4436 34.5394 65.4436 32.7616 64.1103L-2.99805 37.2906Z",
    fill: "url(#pp_paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.99805 37.2897L30.7216 11.9999C32.4994 10.6666 34.9438 10.6666 36.7216 11.9999L72.4812 38.8197L38.7616 64.1094C36.9838 65.4427 34.5394 65.4427 32.7616 64.1094L-2.99805 37.2897Z",
    fill: "url(#pp_paint3_linear)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerPagesScalable);
export default __webpack_public_path__ + "static/media/PowerPages_scalable.e12e6cfc51ec041de38dc78fafa976d6.svg";
export { ForwardRef as ReactComponent };